export class ApiConfig {
  brandMenuUrl!: string;
  baseUrl!: string;
  doloresUrl!: string;
  blackbirdgoUrl!: string;
  dispensaryUrl!: string;
}
